import type { IDPHint } from './constants';
import { getLocalStorage } from './internal/helpers/local-storage';

const LOCAL_STORAGE_KEY_IDP_HINT = 'kc-idp-hint';

export function saveIdpHintToLocalStorage(hint: IDPHint): void {
  try {
    getLocalStorage()?.setItem(LOCAL_STORAGE_KEY_IDP_HINT, hint);
  } catch (error) {
    console.error('Error saving IDP hint to local storage', error);
  }
}

export function getIdpHintFromLocalStorage(): IDPHint | undefined {
  try {
    const hint = getLocalStorage()?.getItem(LOCAL_STORAGE_KEY_IDP_HINT);
    return hint ? (hint as IDPHint) : undefined;
  } catch (error) {
    console.error('Error getting IDP hint from local storage', error);
    return undefined;
  }
}

export function clearIdpHintFromLocalStorage(): void {
  try {
    getLocalStorage()?.removeItem(LOCAL_STORAGE_KEY_IDP_HINT);
  } catch (error) {
    console.error('Error clearing IDP hint from local storage', error);
  }
}
